import { throttle } from "lodash";
import { onBeforeUnmount, onMounted, ref } from "vue";
import { clearAuthStorage } from "./useHelpers";

export const MAX_NO_ACTIVITY_IN_MS = 1800000; // 30 minutes
export const WARNING_TIME_IN_MS = 300000; // 5 minutes

export const useInteractionTimer = () => {
  // Defaults
  const INTERACTION_THROTTLE_IN_MS = 1000; // 1 second
  const RESET_TIMER_ON_EVENTS = [
    "mousemove",
    "scroll",
    "keydown",
    "click",
    "touchstart",
  ];

  // User interaction detection
  const showCountdownModal = ref<boolean>(false);
  const noInteractionTimer = ref<number>(0);
  const timer = ref<[number, number] | null>(null);

  const logout = () => {
    clearAuthStorage();

    window.location.reload();
  };

  /**
   * Converts a duration in milliseconds to a tuple containing minutes and seconds.
   *
   * @param ms - The duration in milliseconds.
   * @returns A tuple where the first element is the number of minutes and the second element is the number of seconds (zero-padded to two digits).
   */
  const msToMinutesAndSeconds = (ms: number): [number, number] => {
    const minutes = Math.floor(ms / 60000);
    const seconds = Math.floor((ms % 60000) / 1000);

    return [minutes, Number(seconds.toString().padStart(2, "0"))];
  };

  const handleInteraction = throttle(() => {
    if (showCountdownModal.value) {
      return;
    }

    noInteractionTimer.value = 0;
  }, INTERACTION_THROTTLE_IN_MS);

  const resetTimer = () => {
    noInteractionTimer.value = 0;
    showCountdownModal.value = false;
  };

  const interactionTimer = () => {
    noInteractionTimer.value += 1000;

    if (noInteractionTimer.value < MAX_NO_ACTIVITY_IN_MS - WARNING_TIME_IN_MS) {
      return;
    }

    // Calculate milliseconds left until logout
    const msLeft = MAX_NO_ACTIVITY_IN_MS - noInteractionTimer.value;

    //calculate time left
    timer.value = msToMinutesAndSeconds(msLeft);

    // Show countdown bar
    showCountdownModal.value = true;

    // Logout if time is expired
    if (msLeft <= 0) {
      // logout();
    }
  };

  onMounted(() => {
    setInterval(interactionTimer, 1000);

    // Reset timer on interaction
    RESET_TIMER_ON_EVENTS.forEach((event) => {
      document.body.addEventListener(event, handleInteraction);
    });
  });

  onBeforeUnmount(() => {
    // Remove event listeners
    RESET_TIMER_ON_EVENTS.forEach((event) => {
      document.body.removeEventListener(event, handleInteraction);
    });
  });

  return {
    showCountdownModal,
    timer,
    resetTimer,
    logout,
  };
};
